// Copyright (C) 2013 Minted Inc.
// All Rights Reserved

M.Model = M.Model || {};
M.Model.ProductDetails = M.Model.ProductDetails || {};

/**
 * @class M.Model.ProductDetails.Accessory
 *
 * Model for a single accessory option on the product details page.
 *  "id": 1262, (minted_product_accessory.id)
 *  "sku": "MIN-31Q-DIR",
 *  "description": 'Snowflake Direction Cards',
 *  "url": "http://www.minted.com/product/direction-cards/MIN-31Q-DIR/twine"
 *
 */
M.Model.ProductDetails.Accessory = Backbone.Model.extend();
